<template>
  <div
    class="ce-slider slider-container"
    v-if="objectdata && objectdata.slideritems && objectdata.slideritems.length > 0"
  >
    <div
      class="slider-background"
      v-for="(slide, index) in objectdata.slideritems"
      :key="slide.id"
      v-if="slide.sliderbackgroundimage && objectdata.slideritems.length > 0"
      :style="'background-image:url(' + slide.sliderbackgroundimage + ')'"
      :data-bg-item="(index)"
    ></div>
    <div v-else class="slider-background"></div>

    <!-- :infiniteScroll="true" -->
    <hooper
      class="slider-wrapper"
      :centerMode="true"
      :wheelControl="false"
      :mouseDrag="false"
      :playSpeed="1000"
      :transition="startTransition"
      :autoPlay="autoplay"
      @slide="nextSlideHeight"
      @afterSlide="checkPlayVideo"
      @loaded="checkSlider;"
      :initialSlide="0"
      :itemsToShow="1"
      :rtl="false"
    >
      <slide
        class="slide-item"
        v-for="slide in objectdata.slideritems"
        :key="slide.id"
        :class="composeSliderClass(slide.slidertype)"
      >
        <div
          v-if="slide.slidertype === '1'"
          :class="composeSliderClass(slide.slidertype)"
          :data-product-bg="slide.sliderbackgroundimage"
          @click="(slide.url ? $router.push(slide.url) : false)"
        >
          <img :src="slide.sliderproductimage" />
        </div>
        <div
          v-else-if="slide.slidertype === '2'"
          :class="composeSliderClass(slide.slidertype)"
          :data-product-bg="slide.sliderbackgroundimage"
          @click="(slide.url ? $router.push(slide.url) : false)"
        >
          <div class="slider-text">
            <h1>
              {{slide.sliderheadline}}
              <br />
              <small>{{slide.slidersubheadline}}</small>
            </h1>
          </div>
        </div>
        <div
          v-else-if="slide.slidertype === '3'"
          :class="composeSliderClass(slide.slidertype)"
          @click="(slide.url ? $router.push(slide.url) : false)"
        >
          <video autoplay="autoplay">
            <source :src="slide.slidervideo" type="video/mp4" />
          </video>
        </div>
        <div
          v-else-if="slide.slidertype === '4'"
          :class="composeSliderClass(slide.slidertype)"
          @click="(slide.url ? $router.push(slide.url) : false)"
        >
          <article class="tile-teaser tile-teaser--big">
            <figure>
              <img :src="slide.sliderimage" />
            </figure>
            <header>
              <h2>{{slide.sliderheadline}}</h2>
              <div v-html="slide.slidertext" />
            </header>
          </article>
        </div>
      </slide>
      <div
        slot="hooper-addons"
        @click="$children[0].$children[0].$hooper.slidePrev()"
        class="slider-button slider-prev-button"
        style="display: block;"
      >
        <span></span>
      </div>
      <div
        slot="hooper-addons"
        @click="$children[0].$children[0].$hooper.slideNext()"
        class="slider-button slider-next-button"
        style="display: block;"
      >
        <span></span>
      </div>
      <!-- <hooper-navigation slot="hooper-addons"></hooper-navigation> -->
      <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </hooper>
  </div>
  <div v-else>Keine Slideritems</div>
</template>
<script>
import Base from "./Base.vue";
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from "hooper";
// import "hooper/dist/hooper.css";
export default {
  extends: Base,
  props: {
    type: false,
    autoplay: false,
    beforeclick: false,
    objectdata: {}
  },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data() {
    return {
      startTransition: 2500,
      tmpArray: []
    };
  },
  created() {
    // console.log("crate");
  },
  methods: {
    postInit() {},
    composeSliderClass(id) {
      if (id == "1") {
        return "slider-item slider-item--bg-product";
      } else if (id == "2") {
        return "slider-item slider-item--image-headline";
      } else if (id == "3") {
        return "slider-item slider-item--video";
      } else if (id == "4") {
        return "slider-item slider-item--tile-teaser";
      }
    },
    checkSlider(event) {
      //

      setTimeout(() => {
        this.nextSlideHeight("init");
        // this.startTransition = 2500;
        if (typeof hooper !== "undefined") {
          this.startTransition = 2500;
          hooper.startTransition = 2500;
          hooper.restart();
        }
      }, 100);
    }
  },
  composed: {}
};
</script>

<style lang="scss">
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";
// SLIDER
// slider variables
$slider-nav-icon--next: "data:image/svg+xml,%3Csvg version='1.1' id='icon-arrow-right' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 17.7 13.3' style='enable-background:new 0 0 17.7 13.3;' xml:space='preserve'%3E%3Cpolygon class='st0' style='fill:%23ffffff;' points='9.9,0.4 9.9,4.4 0.4,4.4 0.4,8.9 9.9,8.9 9.9,12.9 17.2,6.6 '/%3E%3C/svg%3E";
$slider-nav-icon--prev: "data:image/svg+xml,%3Csvg version='1.1' id='icon-arrow-left' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 17.7 13.3' style='enable-background:new 0 0 17.7 13.3;' xml:space='preserve'%3E%3Cpolygon class='st0' style='fill:%23ffffff;' points='7.7,12.9 7.7,8.9 17.2,8.9 17.2,4.4 7.7,4.4 7.7,0.4 0.4,6.6 '/%3E%3C/svg%3E";
$slider-nav-alpha: 0.2;
$slider-nav-icon--size: 20px;
// slider styles

// hooper
.hooper {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: auto;
}
.hooper * {
  box-sizing: border-box;
}
.hooper-list {
  overflow: hidden;
  width: 100%;
  height: 100%;
  // &:focus {
  // 	outline: none;
  // }
}
.hooper-track {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  margin: 0;
}
.hooper.is-vertical .hooper-track {
  flex-direction: column;
}
.hooper.is-rtl {
  direction: rtl;
}
.hooper-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.hooper-slide {
  flex-shrink: 0;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}
.hooper-progress {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  background-color: #efefef;
}
.hooper-progress-inner {
  height: 100%;
  background-color: #4285f4;
  transition: 0.3s;
}
.hooper-pagination {
  position: absolute;
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
  display: flex;
  padding: 5px 10px;
}
.hooper-indicators {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
.hooper-indicator.is-active,
.hooper-indicator:hover {
  background-color: #4285f4;
}
.hooper-indicator {
  margin: 0 2px;
  width: 12px;
  height: 4px;
  border-radius: 4px;
  border: none;
  padding: 0;
  background-color: #fff;
  cursor: pointer;
}
.hooper-pagination.is-vertical {
  bottom: auto;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.hooper-pagination.is-vertical .hooper-indicators {
  flex-direction: column;
}
.hooper-pagination.is-vertical .hooper-indicator {
  width: 6px;
}
.hooper-next,
.hooper-prev {
  background-color: transparent;
  border: none;
  padding: 1em;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.hooper-next.is-disabled,
.hooper-prev.is-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.hooper-next {
  right: 0;
}
.hooper-prev {
  left: 0;
}
.hooper-navigation.is-vertical .hooper-next {
  top: auto;
  bottom: 0;
  transform: initial;
}
.hooper-navigation.is-vertical .hooper-prev {
  top: 0;
  bottom: auto;
  right: 0;
  left: auto;
  transform: initial;
}
.hooper-navigation.is-rtl .hooper-prev {
  left: auto;
  right: 0;
}
.hooper-navigation.is-rtl .hooper-next {
  right: auto;
  left: 0;
}
// /hooper
.slider-container {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center bottom;
  position: relative;
  width: 100%;
  .slider-wrapper {
    // border: 1px solid #f00;
    margin: 0 auto 50px;
    position: relative;
    width: 100%;
    max-width: $maxwidth-content;
    @include min-screen($screen-min-content) {
      margin-bottom: 80px;
    }
    &:focus {
      outline: none;
    }
  }
  .slider-background {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center bottom;
    bottom: 0;
    // display: none;
    opacity: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity 0.75s ease-in-out;
    &.js-active {
      opacity: 1;
    }
  }
  .slide-item {
    overflow: hidden;
    text-align: center;
    // img {
    // 	opacity: 0;
    // 	visibility: hidden;
    // 	transition: opacity 1s ease-in-out;
    // }
    // &.is-active {
    // 	img {
    // 		opacity: 1;
    // 	}
    // }
  }
  .hooper-list {
    // height: auto;
    height: 0;
    transition: height 0.5s ease-in-out;
    // max-height: 550px;
  }
  // .hooper-navigation {
  // 	@include min-screen($screen-min-m) {
  // 		height: 75px;
  // 		left: 50%;
  // 		margin: 0 auto;
  // 		position: absolute;
  // 		transform: translate(-50%, -50%);
  // 		top: 50%;
  // 		width: 100%;
  // 		max-width: $maxwidth-content;
  // 		z-index: 1;
  // 	}
  // 	.hooper-next,
  // 	.hooper-prev {
  // 		background: $color-white;
  // 		background: rgba($color-black-rgb, $slider-nav-alpha);
  // 		border-radius: 100%;
  // 		box-shadow: 0px 0px 51px -15px rgba(0, 0, 0, 0.75);
  // 		cursor: pointer;
  // 		height: 45px;
  // 		position: absolute;
  // 		top: 50%;
  // 		right: 20px;
  // 		transform: translateY(-50%);
  // 		width: 45px;
  // 		z-index: 2;

  // 		@include min-screen($screen-min-m) {
  // 			height: 75px;
  // 			margin-top: -38px;
  // 			width: 75px;
  // 		}

  // 		span {
  // 			display: block;
  // 			height: auto;
  // 			margin: 0 auto;
  // 			top: 55%;
  // 			position: relative;
  // 			transform: translateY(-50%);
  // 			width: $slider-nav-icon--size;

  // 			&:before {
  // 				content: url($slider-nav-icon--next);
  // 			}
  // 		}

  // 		@include min-screen($screen-min-m) {
  // 			transform: scale(1);
  // 			transition: transform 0.2s ease-in-out;

  // 			&:hover {
  // 				transform: scale(1.1);
  // 			}
  // 		}
  // 	}
  // 	.hooper-prev {
  // 		left: 20px;
  // 		right: auto;

  // 		span {
  // 			&:before {
  // 				content: url($slider-nav-icon--prev);
  // 			}
  // 		}
  // 	}
  // }

  .hooper-pagination {
    display: block;
    text-align: center;
    width: 100%;
    @include min-screen($screen-min-content) {
      bottom: 20px;
      // display: table;
      padding: 0;
      position: absolute;
      left: 50%;
      text-align: center;
      transform: translateX(-50%);
    }

    .hooper-indicators {
      display: inline-block;
      list-style: none;
      padding: 0;
      width: auto;
      z-index: 2;

      li {
        display: inline-block;
        margin: 0;
        &:focus,
        &:active {
          outline: none;
        }
        &:before {
          content: "";
        }
        button {
          background: transparent;
          border: 2px solid $color-green;
          @include border-radius(100%);
          display: inline-block;
          height: 10px;
          margin: 0 10px 10px;
          opacity: 1;
          width: 10px;
          &:focus,
          &:active {
            outline: none;
          }
          @include min-screen($screen-min-m) {
            height: 15px;
            width: 15px;
          }

          &.is-active {
            background: $color-green;
          }

          // button {
          // 	display: none;
          // }
        }
      }
    }
  }
}

.slider-next-button,
.slider-prev-button {
  background: $color-white;
  background: rgba($color-black-rgb, $slider-nav-alpha);
  border-radius: 100%;
  box-shadow: 0px 0px 51px -15px rgba(0, 0, 0, 0.75);
  cursor: pointer;
  height: 45px;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 45px;
  z-index: 2;
  &:focus {
    outline: none;
  }

  @include min-screen($screen-min-m) {
    height: 75px;
    margin-top: -38px;
    width: 75px;
  }

  span {
    display: block;
    height: auto;
    margin: 0 auto;
    top: 55%;
    position: relative;
    transform: translateY(-50%);
    width: $slider-nav-icon--size;

    &:before {
      content: url($slider-nav-icon--next);
    }
  }

  @include min-screen($screen-min-m) {
    transform: scale(1);
    transition: transform 0.2s ease-in-out;

    &:hover {
      transform: scale(1.1);
    }
  }
}

.slider-prev-button {
  left: 20px;
  right: auto;

  span {
    &:before {
      content: url($slider-nav-icon--prev);
    }
  }
}
.slider-item--video {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  width: 100%;
  // height: auto;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.slider-item--bg-product {
  padding: 20px 0 10px;
  @include min-screen($screen-min-content) {
    padding: 80px 0 40px;
  }
  img {
    max-height: 250px;
    margin: 0 auto 0;
    // margin-bottom: 5%;
    @include min-screen($screen-min-content) {
      max-height: 450px;
    }
  }
}
.slider-item--image-headline {
  min-height: 350px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  .slider-text {
    h1,
    h2 {
      color: $color-white;
    }
  }
  @include min-screen($screen-min-content) {
    min-height: 530px;
  }
}
header {
  // display: none;
}
</style>